
    import '/opt/buildhome/repo/docs/playground/independent.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-playground-independent-demo-independent"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/docs/playground/independent.zh-CN.md?type=demo')
};